export function racingConfig() {
    return {
        NextRaces: {
            swiper: {
                style: {
                    height: 'initial',
                    minHeight: '247px',
                },
            },
        },
    };
}
